import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "../Sidebar";
import {
  Divider,
  Paper,
  Typography,
  LinearProgress,
  Button,
  Grid,
  requirePropFactory,
  Backdrop,
  Checkbox,
  Switch,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import CloseIcon from "@mui/icons-material/Close";
import {
  Tooltip,
  IconButton,
  Modal,
  TableBody,
  Table,
  TableContainer,
  TablePagination,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import ReadMoreIcon from  '@mui/icons-material/ReadMore';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import loader from '../img/ltm.gif'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon  from '@mui/icons-material/FileCopyOutlined';
import SupervisorAccountOutlinedIcon  from '@mui/icons-material/Diversity1Outlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import base from '../../src/base.json'
import Diversity3Icon from '@mui/icons-material/Diversity3';
import GroupsIcon from '@mui/icons-material/Groups';



const drawerWidth = 80;
export class VendorsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      

     vendorList : [],
     page : 0,
     rowsPerPage : 10,
     vendors_count : 0,

     ////////// analytics details /////////////////

                   customer_count : 0,
                   frenchise_count : 0,
                   unverified_vendor : 0,



       is_vendor_delete : false,
       is_loader_shows : false,
       vendor_id  :""
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSearchChange = (e) => {
   
  };



  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.instantRetrive();
    });
  };



  handleChangeRowsPerPage = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      () => {
        this.instantRetrive();
      }
    );
  };



  componentDidMount() {
    //// retrive leads list here for display
    this.setState({is_loader_shows:true},()=>{
      fetch(
           `${base.base_url}/admin/retriveVendorList/:${this.state.page}/:${this.state.rowsPerPage}`,
           {
              headers: {
                      "Content-Type":"application/json"
                        },
             method: "get",
           }
         )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
             this.setState({
               vendorList: result.data,
               vendors_count: result.size,
               is_loader_shows : false
             });
           });


        fetch(
           `${base.base_url}/admin/getAnalyticalDetails`,
           {
              headers: {
                      "Content-Type":"application/json"
                        },
             method: "get",
           }
         )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
                this.setState({
                  customer_count : result.customer_count,
                   frenchise_count : result.frenchise_count,
                   unverified_vendor : result.unverified_vendor,
                });
           });

      
    })

  }




  instantRetrive = () => {
      fetch(
           `${base.base_url}/admin/retriveVendorList/:${this.state.page}/:${this.state.rowsPerPage}`,
           {
             method: "get",
           }
          )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
             this.setState({
               vendorList: result.data,
               vendors_count: result.size,
               is_loader_shows : false
             });
           });
  };



sucessfull=(data)=>{
    toast.success(data, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      //transition: Bounce,
      });
  }


  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            {
              /// header data
            }
            <Box
              sx={{
                height: 47,
                width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>Vendors List </Typography>

              <Box sx={{ display: "flex", flexDirection: "row", mr: 1 }}>
                <Button
                  variant="contained"
                  size="samll"
                  startIcon={<FormatListBulletedIcon sx={{height:20,width:20}}/>}
                  disableElevation
                  onClick={()=>this.setState({is_export_ : true})}
                  sx={{
                    height: 25,
                    textTransform: "none",
                    fontSize:13,
                    backgroundColor: "#877bff",
                  }}
                >
                   Add Vendors
                </Button>
            

              </Box>
            </Box>

       

      
            <Box sx={{ paddingLeft: 3, paddingRight: 3, paddingTop: 2,display:this.state.is_loader_shows?'none':'block' }}>

                <Box>
                   <Grid container spacing={2}>
                     <Grid size={{xs:12,sm:6,md:2.4}}>
                      <Paper sx={{height:80,width:'100%',display:'flex',flexDirection:'row',alignItems:'center'}}>

                          <Box sx={{height:45,width:45,backgroundColor:'#64baff',borderRadius:11,ml:2,display:'flex',justifyContent:'center',alignItems:'center'}}>
                           <GroupsIcon sx={{color:'#fff'}}/>
                          </Box>

                          <Box sx={{display:'flex',flexDirection:'column',ml:1}}>
                           <Typography sx={{fontSize:12,fontWeight:'bold',textTransform:'uppercase',color:'#5e5e5e'}}>Total Customers</Typography>
                           <Typography sx={{fontSize:18,fontWeight:'700'}}>{this.state.customer_count}</Typography>
                          </Box>


                      </Paper>
                     </Grid>
                     

                      <Grid size={{xs:12,sm:6,md:2.4}}>
                       <Paper sx={{height:80,width:'100%',display:'flex',flexDirection:'row',alignItems:'center'}}>

                          <Box sx={{height:45,width:45,backgroundColor:'green',borderRadius:11,ml:2,display:'flex',justifyContent:'center',alignItems:'center'}}>
                           <SupervisorAccountOutlinedIcon sx={{color:'#fff'}}/>
                          </Box>

                          <Box sx={{display:'flex',flexDirection:'column',ml:1}}>
                           <Typography sx={{fontSize:12,fontWeight:'bold',textTransform:'uppercase',color:'#5e5e5e'}}>Verified Vendors</Typography>
                           <Typography sx={{fontSize:18,fontWeight:'700'}}>{this.state.vendors_count}</Typography>
                          </Box>


                      </Paper>
                     </Grid>
                    
 
      <Grid size={{xs:12,sm:6,md:2.4}}>
                       <Paper sx={{height:80,width:'100%',display:'flex',flexDirection:'row',alignItems:'center'}}>

                          <Box sx={{height:45,width:45,backgroundColor:'#f29494',borderRadius:11,ml:2,display:'flex',justifyContent:'center',alignItems:'center'}}>
                           <SupervisorAccountOutlinedIcon sx={{color:'#fff'}}/>
                          </Box>

                          <Box sx={{display:'flex',flexDirection:'column',ml:1}}>
                           <Typography sx={{fontSize:12,fontWeight:'bold',textTransform:'uppercase',color:'#5e5e5e'}}>Pending Vendors</Typography>
                           <Typography sx={{fontSize:18,fontWeight:'700'}}>{this.state.unverified_vendor}</Typography>
                          </Box>


                      </Paper>
                     </Grid>
                       

                        <Grid size={{xs:12,sm:6,md:2.4}}>
                         <Paper sx={{height:80,width:'100%',display:'flex',flexDirection:'row',alignItems:'center'}}>

                          <Box sx={{height:45,width:45,backgroundColor:'#64baff',borderRadius:11,ml:2,display:'flex',justifyContent:'center',alignItems:'center'}}>
                           <Diversity3Icon sx={{color:'#fff'}}/>
                          </Box>

                          <Box sx={{display:'flex',flexDirection:'column',ml:1}}>
                           <Typography sx={{fontSize:12,fontWeight:'bold',textTransform:'uppercase',color:'#5e5e5e'}}>Total Frenchise</Typography>
                           <Typography sx={{fontSize:17,fontWeight:'700'}}>{this.state.frenchise_count}</Typography>
                          </Box>


                      </Paper>
                     </Grid>
                     

                      <Grid size={{xs:12,sm:6,md:2.4}}>
                        <Paper sx={{height:80,width:'100%',display:'flex',flexDirection:'row',alignItems:'center'}}>

                          <Box sx={{height:45,width:45,backgroundColor:'#64baff',borderRadius:11,ml:2,display:'flex',justifyContent:'center',alignItems:'center'}}>
                           <LanguageOutlinedIcon sx={{color:'#fff'}}/>
                          </Box>

                          <Box sx={{display:'flex',flexDirection:'column',ml:1}}>
                           <Typography sx={{fontSize:12,fontWeight:'bold',textTransform:'uppercase',color:'#5e5e5e'}}>Today Orders</Typography>
                           <Typography sx={{fontSize:18,fontWeight:'700'}}>10</Typography>
                          </Box>

                      </Paper>
                     </Grid>


                   </Grid>
                </Box>


<Box sx={{mt:2,mb:2}}>
  <Button variant="contained" size="small" onClick={()=>this.props.navigate('/pendingVendor')} sx={{fontSize:11}}>Pending Vendor List</Button>
</Box>
      




              <Box sx={{ mt: 2, padding: 0 }}>
                <Paper
                  variant="outlined"
                  sx={{ minHeight: 250, width: "100%" }}
                >
                  <TableContainer
                    component={Box}
                    sx={{ backgroundColor: "#f4f4f6" }}
                  >
                    <Table
                      sx={{ minWidth: 1720 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           ID
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Vender Name
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           City
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                            State
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Pincode
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                            Contact No
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                            Email Id
                          </TableCell>

                             <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                            Bank Account No
                          </TableCell>

                           <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           IFSC Code
                          </TableCell>

                           <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Bank Name
                          </TableCell>

                           <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                          Is Ads Active
                          </TableCell>
 
                                 <TableCell
                            align="center"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                          Is Active
                          </TableCell>
            
                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.vendorList.map((row, index) => (
                          <TableRow
                            key={row.lead_id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                              backgroundColor: index % 2 ? "#f9f9f9" : "#fff",
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{ color: "#42526e" }}
                            >
                              <Box
                                sx={{
                                  height: 20,
                                  minWidth: 60,
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                  }}
                                >
                                 {(this.state.page * this.state.rowsPerPage)+index +1 }
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                color: "#42526e",
                                textTransform: "uppercase",
                                minWidth: 100,
                              }}
                            >
                              <Box
                                sx={{
                                  height: 20,
                                  minWidth: 60,
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: "600",
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                  }}
                                >
                                 {row.vendor_personal_sirname} {row.vendor_personal_first_name} {row.vendor_personal_last_name}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                color: "#42526e",
                                textTransform: "uppercase",
                                minWidth: 100,
                              }}
                            >
                              <Box
                                sx={{
                                  height: 20,
                                  minWidth: 60,
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: "500",
                                    paddingLeft: 1,
                                    paddingRight: 1,
                                  }}
                                >
                                 {row.vender_personal_city}
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight:'600'
                              }}
                            >
                               {row.vender_personal_state}
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight:'600'
                              }}
                            >
                               {row.vender_personal_pincode}
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight:'600'
                              }}
                            >
                               {row.vendor_personal_contact_number}
                            </TableCell>
                              <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight:'600'
                              }}
                            >
                             {row.vender_personal_email}
                            </TableCell>
                      
                            <TableCell
                              align="center"
                              sx={{ color: "#42526e", fontSize: 12 }}
                            >
                           {row.vender_personal_bank_account_no}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ color: "#42526e", fontSize: 12 }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                   {row.vendor_personal_bank_ifsc_code}
                                  
                              </Box>
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                fontSize: 12,
                                minWidth: 100,
                              }}
                            >

                              {row.vendor_personal_bank_name}
                              
                            </TableCell>

                                     <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                fontSize: 12,
                                minWidth: 100,
                              }}
                            >

                             <Switch onClick={()=>{
                               fetch(`${base.base_url}/vendor/v_/take_advertisement_package_for_vender`, {
        
          headers: {
            "content-type": "application/json",
                    },
                                
        method: "post",
        body: JSON.stringify({
          id:row._id
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((d) => {
  
         this.instantRetrive();
          
        }); 
      
                             }} size="small" checked={row.is_vender_taken_advertisement_packaage} />
                              
                            </TableCell>

                                  <TableCell
                              align="center"
                              sx={{
                                color: "#42526e",
                                fontSize: 12,
                                minWidth: 100,
                              }}
                            >

                             <Switch size="small" checked={row.is_active} onClick={()=>{
                               
        fetch(
           `${base.base_url}/admin/changeVendorActiveOrInactive`,
           {
              headers: {
                      "Content-Type":"application/json"
                        },
             method: "put",
             body:JSON.stringify({
              vendor_id : row.vendor_id,
              is_active : row.is_active?false:true
             })
           }
          )
           .then((res) => {
             return res.json();
           })
           .then(() => {
              this.instantRetrive();
           });

                             }}/>
                              
                            </TableCell>
              
                            <TableCell align="right">
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "right",
                                }}
                              >

                                <Tooltip title="EDIT">
                                  <Link to={`/editVendor/:${row.vendor_id}`}>
                                  <IconButton size="small" >
                                    <EditIcon
                                      sx={{
                                        color: "#00cfe8",
                                        height: 17,
                                        width: 17,
                                      }}
                                    />
                                  </IconButton>
                                  </Link>
                                </Tooltip>
                        
                              <Tooltip title="DELETE">
                                  <IconButton size="small" onClick={()=>{
                                    this.setState({
                                      vendor_id : row._id,
                                      is_vendor_delete :true
                                    })
                                  }}>
                                    <DeleteOutlinedIcon
                                      sx={{
                                        color: "red",
                                        height: 17,
                                        width: 17,
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title="Descriptions">
                                  <IconButton size="small"  onClick={()=>this.props.navigate(`/pendingVendorDesc/:${row.vendor_id}`)}>
                                    <ReadMoreIcon
                                      sx={{
                                        color: "green",
                                        height: 20,
                                        width: 20,
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>


                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Divider />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={this.state.vendors_count}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </Paper>
              </Box>



            </Box>
          </Box>
        </Box>










{
  //// delete vendor details
}


        <Box>
          <Modal
            open={this.state.is_vendor_delete}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() =>
                        this.setState({ is_vendor_delete: false })
                      }
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(`${base.base_url}/admin/deleteVendorDetails`, {
                          headers: {
                            "content-type": "application/json",
                          },
                          method: "delete",
                          body: JSON.stringify({
                            id: this.state.vendor_id,
                          }),
                        })
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              vendor_id: "",
                              is_vendor_delete : false,
                            });
                            this.instantRetrive();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>



        <Backdrop
   sx={(theme) => ({ backgroundColor:'transparent', zIndex: theme.zIndex.drawer + 1 })}
  open={this.state.is_loader_shows}
  onClick={this.handleClose}
>
<Paper elevation={0} sx={{height:70,width:70,display:'flex',justifyContent:'center',alignItems:'center'}}>
<img  src={loader} style={{height:67,width:67}}/>
</Paper>
        </Backdrop>

        
        <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        //transition={Bounce}
        />


      </Box>
    );
  }
}

export default VendorsList;


export function VendorsListc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<VendorsList param={param} navigate={navigate}></VendorsList>)
}















